import React from 'react';
import { Styles } from './styles';
import { ListTypeEnum } from './types';
import { IProperty } from '@stores/Property/types';
import { useNavigate } from 'react-router-dom';
import { usePropertyStore } from '@stores/Property/Property';
import { useUserStore } from '@stores/User/User';
import { UserRole } from '@stores/User/types';

interface CardButtonsContentProps {
  listType?: ListTypeEnum;
  property: IProperty;
}

function CardContentButtons({
  listType = ListTypeEnum.ATIVOS,
  property
}: CardButtonsContentProps) {
  const navigate = useNavigate();
  const { role } = useUserStore();
  const { approveProperty } = usePropertyStore();

  const handleApprove = async (propertyId: string) => {
    const success = await approveProperty(propertyId);
    if (success) {
      navigate('/area-do-corretor/imoveis/listagem/ativos');
    } else {
      alert('Erro ao aprovar o imóvel. Tente novamente.');
    }
  };

  switch (listType) {
    case ListTypeEnum.APROVANDO:
      if (role === UserRole.ADMIN) {
        return (
          <Styles.CardButtons>
            <Styles.ActionButton
              $bg="#04682E"
              $hover="#034D21"
              onClick={() => handleApprove(property.id)}>
              Aprovar
            </Styles.ActionButton>
            <Styles.ActionButton
              $bg="#000000"
              $hover="#333333"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/editar/${property.id}`)
              }>
              Editar
            </Styles.ActionButton>
          </Styles.CardButtons>
        );
      } else {
        return (
          <Styles.CardButtons>
            <Styles.ActionButton
              $bg="#2C62C7"
              $hover="#1E4A8E"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/consultar/${property.id}`)
              }>
              Visualizar
            </Styles.ActionButton>
            <Styles.ActionButton
              $bg="#000000"
              $hover="#333333"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/editar/${property.id}`)
              }>
              Editar
            </Styles.ActionButton>
          </Styles.CardButtons>
        );
      }
    case ListTypeEnum.ATIVOS:
    default:
      if (role === UserRole.ADMIN) {
        return (
          <Styles.CardButtons>
            <Styles.ActionButton
              $bg="#2C62C7"
              $hover="#1E4A8E"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/consultar/${property.id}`)
              }>
              Visualizar
            </Styles.ActionButton>
            <Styles.ActionButton
              $bg="#000000"
              $hover="#333333"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/editar/${property.id}`)
              }>
              Editar
            </Styles.ActionButton>
          </Styles.CardButtons>
        );
      } else if (role === UserRole.SECRETARIA) {
        return (
          <Styles.CardButtons>
            <Styles.ActionButton
              $bg="#2C62C7"
              $hover="#1E4A8E"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/consultar/${property.id}`)
              }>
              Visualizar
            </Styles.ActionButton>
            <Styles.ActionButton
              $bg="#000000"
              $hover="#333333"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/editar/${property.id}`)
              }>
              Editar
            </Styles.ActionButton>
          </Styles.CardButtons>
        );
      } else {
        return (
          <Styles.CardButtons>
            <Styles.ActionButton
              $bg="#2C62C7"
              $hover="#1E4A8E"
              onClick={() =>
                window.open(
                  `/imoveis/${property.id}`,
                  '_blank',
                  'rel=noopener noreferrer'
                )
              }>
              Ver Anúncio
            </Styles.ActionButton>
            <Styles.ActionButton
              $bg="#000000"
              $hover="#333333"
              onClick={() =>
                navigate(`/area-do-corretor/imoveis/consultar/${property.id}`)
              }>
              Ver Dados
            </Styles.ActionButton>
          </Styles.CardButtons>
        );
      }
  }
}

interface CardButtonsProps {
  listType?: ListTypeEnum;
  property: IProperty;
}

export function CardButtons({ listType, property }: CardButtonsProps) {
  const getPropertyCod = (property: IProperty): string => {
    if (!property.cod_imovel) return '';
    if (typeof property.cod_imovel === 'string') {
      return `${property.cod_imovel}${property.id}`;
    }
    return `${property.cod_imovel.cod}${property.id}`;
  };
  return (
    <Styles.CardButtonsWrapper>
      <Styles.CardButtonsTitle>{`${property.titulo} ${getPropertyCod(property)}`}</Styles.CardButtonsTitle>
      <CardContentButtons listType={listType} property={property} />
    </Styles.CardButtonsWrapper>
  );
}
